import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';

export function deviceType() {
  const isMobile =
    typeof window.matchMedia === 'function' &&
    window.matchMedia(
      `only screen and (max-device-width: ${designTokens.breakpoints.md.value - 1}px)`
    ).matches;

  const isTablet =
    typeof window.matchMedia === 'function' &&
    window.matchMedia(
      `only screen and (min-device-width: ${designTokens.breakpoints.md.value}px) and (max-device-width: ${designTokens.breakpoints.lg.value - 1}px)`
    ).matches;

  if (isMobile) {
    return 'Mobile';
  } else if (isTablet) {
    return 'Tablet';
  } else {
    return 'Desktop';
  }
}
